import { render, staticRenderFns } from "./x-chip.vue?vue&type=template&id=15909f36&scoped=true&"
import script from "./x-chip.vue?vue&type=script&lang=js&"
export * from "./x-chip.vue?vue&type=script&lang=js&"
import style0 from "./x-chip.vue?vue&type=style&index=0&id=15909f36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15909f36",
  null
  
)

export default component.exports